import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";
import Features from "./features";

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Pages.Login />} />
      <Route path="/sign-up" element={<Pages.Signup />} />
      <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
      <Route path="/signup-form" element={<Pages.SignupForm />} />
      <Route path="/otp" element={<Pages.OtpVerification />} />
      <Route path="/reset-password" element={<Pages.ResetPassword />} />
      <Route path="/subscription-form" element={<Pages.SubscriptionForm />} />
      <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route path="/manage-users" element={<Pages.ManageUser />} />
        <Route
          path="/manage-users/detail"
          element={<Pages.ManageUserDetail />}
        />
        <Route path="/manage-users/edit" element={<Pages.Edituser />} />
        <Route path="/manage-users/add" element={<Pages.Edituser />} />
        <Route path="/finances" element={<Pages.Finances />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route
          path="/manage-subadmin/detail"
          element={<Pages.SubadminDetail />}
        />
        <Route
          path="/manage-subadmin/roles"
          element={<Pages.ManageSubadminRoles />}
        />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route
          path="/manage-subadmin/roles/detail"
          element={<Pages.RoleDetail />}
        />
        <Route
          path="/manage-notifications"
          element={<Pages.ManageNotifications />}
        />
        <Route
          path="/manage-notifications/add"
          element={<Pages.AddNotification />}
        />
        <Route
          path="/manage-notifications/detail"
          element={<Pages.NotificationDetail />}
        />
        <Route
          path="/recieved-notifications"
          element={<Pages.RecievedNotifications />}
        />
        <Route
          path="/manage-system-settings"
          element={<Pages.ManageSystemSettings />}
        />
        <Route
          path="/manage-system-settings/add-email-template"
          element={<Pages.AddEmailTemplate />}
        />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/store-information" element={<Pages.StoreInformation />} />
        <Route path="/store-management" element={<Pages.StoreManagement />} />
        <Route path="/store-management/add" element={<Pages.AddStoreInfo />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route
          path="/manage-profile/change-password"
          element={<Pages.ChangePassword />}
        />
        <Route path="/revenue" element={<Pages.Revenue />} />
        <Route path="/admin-support" element={<Pages.AdminSupport />} />
        <Route
          path="/admin-support/view"
          element={<Pages.ViewAdminSupport />}
        />
        <Route
          path="/admin-support/knowledge-base"
          element={<Pages.KnowledgeBase />}
        />
        <Route
          path="/admin-support/video-tutorial"
          element={<Pages.VideoTutorials />}
        />

        <Route path="/manage-promotions" element={<Pages.ManagePromotion />} />
        <Route path="/manage-promotions/add" element={<Pages.AddPromotion />} />
        <Route
          path="/manage-promotions/edit"
          element={<Pages.AddPromotion />}
        />
        <Route
          path="/manage-promotions/view"
          element={<Pages.ViewPromotion />}
        />

        <Route path="/manage-qr-code" element={<Pages.ManageQrCode />} />
        <Route path="/manage-rewards" element={<Pages.ManageRewards />} />
        <Route path="/manage-rewards/add" element={<Pages.AddRewards />} />
        <Route
          path="/manage-rewards/detail"
          element={<Pages.RewardsDetail />}
        />
        <Route
          path="/manage-transactions"
          element={<Pages.ManageTransction />}
        />
        <Route
          path="/manage-transactions/view"
          element={<Pages.ViewTransction />}
        />
        <Route
          path="/manage-activity-logs"
          element={<Pages.ManageActivityLogs />}
        />
        <Route
          path="/manage-feedback-and-reports"
          element={<Pages.ManageFeedbackReports />}
        />
        <Route path="/manage-products" element={<Features.manageproducts />} />
        <Route
          path="/manage-products/view/:id"
          element={<Features.ViewProduct />}
        />
        <Route
          path="/manage-inventory"
          element={<Features.ManageInventory />}
        />
        <Route path="/add-product" element={<Features.addProduct />} />
        <Route path="/edit-product/:id" element={<Features.addProduct />} />
        <Route path="/ratings" element={<Features.Ratings />} />
        <Route
          path="/customer-support"
          element={<Features.CustomerSupport />}
        />
        <Route path="/Manage-chat" element={<Features.Chat />} />

        <Route
          path="/order-management"
          element={<Features.OrderManagement />}
        />
        <Route
          path="/order-management/view/:id"
          element={<Features.ViewOrderManagement />}
        />
        <Route path="/marketing" element={<Features.DiscountCoupon />} />
        <Route path="/marketing/add" element={<Features.AddCampaign />} />
        <Route path="/marketing/view" element={<Features.viewDiscount />} />
        <Route path="/marketing/edit" element={<Features.AddCampaign />} />
        <Route path="/subscription" element={<Features.Subscription />} />
        <Route path="/Support" element={<Features.Support />} />
        <Route path="/Settings" element={<Features.Settings />} />
        <Route path="/store-branding" element={<Pages.StoreBranding />} />
        <Route path="/my-orders" element={<Pages.MyOrders />} />
        <Route
          path="/my-orders/view"
          element={<Pages.ViewPurchaseServices />}
        />
        <Route path="/wishlist" element={<Pages.MyWhistlist />} />
        <Route path="/services" element={<Pages.PurchaseServices />} />
        <Route path="/services/view-work" element={<Pages.ViewWork />} />
        <Route path="/services/view" element={<Pages.ViewService />} />
        <Route path="/blogs" element={<Pages.Blogs />} />
        <Route path="/blogs/add" element={<Pages.AddBlog />} />
        <Route path="/blogs/view" element={<Pages.ViewBlogs />} />
        <Route path="/ai-insights" element={<Pages.AiInsights />} />
        <Route path="/ai-insights/view" element={<Pages.ViewAiInsights />} />
        <Route path="/ques-ans" element={<Pages.QuesAns />} />
        <Route path="/license" element={<Pages.TradeLicence />} />
        <Route path="/license/view" element={<Pages.ViewTradeLicence />} />
        <Route path="/faq" element={<Pages.FAQs />} />
        <Route path="/terms" element={<Pages.TermsConditions />} />
        <Route path="/privacy" element={<Pages.PrivacyPolicy />} />
        <Route path="/ques-ans/view" element={<Pages.ViewQuesAns />} />
        <Route path="/referral" element={<Pages.Referral />} />
        <Route path="/referral/add" element={<Pages.AddReferral />} />
        <Route path="/compliance" element={<Pages.ComplianceStatus />} />
        <Route path="/my-subscription" element={<Pages.MySubscription />} />
        <Route path="/transactions" element={<Pages.TransctionLog />} />
        <Route path="/ai-token" element={<Pages.AITokenUtilization />} />
        <Route
          path="/payment-preferences"
          element={<Pages.PaymentPreferences />}
        />
      </Route>
    </Routes>
  );
};

export default Routing;
